import React from 'react';
import { Container, Typography } from '@mui/material';

const Checkout: React.FC = () => {
    return (
        <Container>
            <Typography variant="h4" component="h1" gutterBottom>
                Paiement TOTO
            </Typography>
            {/* Contenu à implémenter */}
        </Container>
    );
};

export default Checkout;